import { IconProps } from '.';

function BadgeWarning({ color, className }: IconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <title>BadgeWarning</title>
      <path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M3.0161 16C0.776681 16 -0.679457 13.6422 0.321889 11.6388L5.30694 1.66513C6.41723 -0.555061 9.58397 -0.555061 10.6943 1.66523L15.6793 11.6388C16.6805 13.642 15.2238 16 12.9851 16H3.0161ZM6.20132 2.11261L1.21632 12.0862C0.547383 13.4245 1.52015 14.9996 3.0161 14.9996H12.9851C14.4804 14.9996 15.4537 13.4242 14.7849 12.0862L9.79994 2.1127C9.05823 0.629563 6.94297 0.629563 6.20132 2.11261ZM8.5005 10.5202V5.47941C8.5005 5.20317 8.27664 4.97923 8.0005 4.97923C7.72436 4.97923 7.5005 5.20317 7.5005 5.47941V10.5202C7.5005 10.7965 7.72436 11.0204 8.0005 11.0204C8.27664 11.0204 8.5005 10.7965 8.5005 10.5202ZM8.0005 13.2292C7.6555 13.2292 7.3755 12.9491 7.3755 12.604C7.3755 12.2589 7.6555 11.9788 8.0005 11.9788C8.3455 11.9788 8.6255 12.2589 8.6255 12.604C8.6255 12.9491 8.3455 13.2292 8.0005 13.2292Z" fill={color} />
    </svg>
  );
}

export default BadgeWarning;
